// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ldio-q7wlrv7fl9q {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ldio-q7wlrv7fl9q div {
  box-sizing: border-box !important;
}

.ldio-q7wlrv7fl9q > div {
  position: absolute;
  width: 46px;
  height: 46px;
  top: 77px;
  left: 77px;
  border-radius: 50%;
  border: 6px solid #000;
  border-color: #2c906b transparent #2c906b transparent;
  animation: ldio-q7wlrv7fl9q 1s linear infinite;
}

.ldio-q7wlrv7fl9q > div:nth-child(2) {
  border-color: transparent;
}

.ldio-q7wlrv7fl9q > div:nth-child(2) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}

.ldio-q7wlrv7fl9q > div:nth-child(2) div:before, .ldio-q7wlrv7fl9q > div:nth-child(2) div:after {
  content: "";
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  top: -6px;
  left: 14px;
  background: #2c906b;
  border-radius: 50%;
  box-shadow: 0 40px 0 0 #2c906b;
}

.ldio-q7wlrv7fl9q > div:nth-child(2) div:after {
  left: -6px;
  top: 14px;
  box-shadow: 40px 0 0 0 #2c906b;
}

.loadingio-spinner-dual-ring-m2lbfya9ixk {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
  background: none;
}

.ldio-q7wlrv7fl9q {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}

.ldio-q7wlrv7fl9q div {
  box-sizing: content-box;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/loading-component/loading-component.component.scss"],"names":[],"mappings":"AAAA;EACE;IAAK,oBAAA;EAEL;EADA;IAAO,yBAAA;EAIP;AACF;AAHA;EAAwB,iCAAA;AAMxB;;AALA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,qDAAA;EACA,8CAAA;AAQF;;AANA;EAAuC,yBAAA;AAUvC;;AATA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;AAYF;;AAVA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AAaF;;AAXA;EACE,UAAA;EACA,SAAA;EACA,8BAAA;AAcF;;AAZA;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AAeF;;AAbA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,2BAAA;EACA,qBAAA,EAAA,mBAAA;AAgBF;;AAdA;EAAwB,uBAAA;AAkBxB","sourcesContent":["@keyframes ldio-q7wlrv7fl9q {\n  0% { transform: rotate(0) }\n  100% { transform: rotate(360deg) }\n}\n.ldio-q7wlrv7fl9q div { box-sizing: border-box!important }\n.ldio-q7wlrv7fl9q > div {\n  position: absolute;\n  width: 46px;\n  height: 46px;\n  top: 77px;\n  left: 77px;\n  border-radius: 50%;\n  border: 6px solid #000;\n  border-color: #2c906b transparent #2c906b transparent;\n  animation: ldio-q7wlrv7fl9q 1s linear infinite;\n}\n.ldio-q7wlrv7fl9q > div:nth-child(2) { border-color: transparent }\n.ldio-q7wlrv7fl9q > div:nth-child(2) div {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  transform: rotate(45deg);\n}\n.ldio-q7wlrv7fl9q > div:nth-child(2) div:before, .ldio-q7wlrv7fl9q > div:nth-child(2) div:after { \n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  top: -6px;\n  left: 14px;\n  background: #2c906b;\n  border-radius: 50%;\n  box-shadow: 0 40px 0 0 #2c906b;\n}\n.ldio-q7wlrv7fl9q > div:nth-child(2) div:after { \n  left: -6px;\n  top: 14px;\n  box-shadow: 40px 0 0 0 #2c906b;\n}\n.loadingio-spinner-dual-ring-m2lbfya9ixk {\n  width: 200px;\n  height: 200px;\n  display: inline-block;\n  overflow: hidden;\n  background: none;\n}\n.ldio-q7wlrv7fl9q {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transform: translateZ(0) scale(1);\n  backface-visibility: hidden;\n  transform-origin: 0 0; /* see note above */\n}\n.ldio-q7wlrv7fl9q div { box-sizing: content-box; }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
